import React, { useState, useEffect } from 'react';
import { CalendarIcon, ClockIcon } from '@heroicons/react/24/outline';

const DateTime = () => {
  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000); // Update every second

    return () => clearInterval(timer);
  }, []);

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  return (
    <div className="flex flex-col sm:flex-row items-center space-y-1 sm:space-y-0 sm:space-x-3 text-gray-700">
      {/* Date Display */}
      <div className="flex items-center space-x-1.5 sm:space-x-2">
        <CalendarIcon className="h-4 w-4 sm:h-5 sm:w-5 text-blue-600" />
        <span className="text-xs sm:text-sm font-medium">
          {formatDate(currentDateTime)}
        </span>
      </div>
      
      {/* Time Display */}
      <div className="flex items-center space-x-1.5 sm:space-x-2">
        <ClockIcon className="h-4 w-4 sm:h-5 sm:w-5 text-green-600" />
        <span className="text-xs sm:text-sm font-medium">
          {formatTime(currentDateTime)}
        </span>
      </div>
    </div>
  );
};

export default DateTime;